import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  TitleStrategy,
} from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly defaultTitle = this.title.getTitle();

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const activeRoute = this.getLeafRoute(snapshot.root);
    const resolvedTitle = this.getResolvedTitleForRoute(activeRoute);

    if (typeof resolvedTitle === 'string' && resolvedTitle.length > 0) {
      this.title.setTitle(`${this.defaultTitle} - ${resolvedTitle}`);
      return;
    }

    const fallbackTitle = this.getFallbackTitle(activeRoute);
    this.title.setTitle(
      fallbackTitle ? `${this.defaultTitle} - ${fallbackTitle}` : this.defaultTitle
    );
  }

  private getLeafRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }

  private getFallbackTitle(route: ActivatedRouteSnapshot): string | undefined {
    const path = route.url[0]?.path;
    if (!path) {
      return undefined;
    }

    return path
      .replace(/-/g, ' ')
      .replace(/\b\w/g, letter => letter.toUpperCase());
  }
}
